import { ArrowUpRightIcon, CheckIcon } from '@langchain/untitled-ui-icons';

import { Text } from '@/design-system';
import { cn } from '@/design-system/utils/cn';

import { OnboardingChecklistCardProps } from './OnboardingChecklistCardRenderer';

export function OnboardingChecklistCardA(props: OnboardingChecklistCardProps) {
  return (
    <div
      className={cn(
        'group flex h-full flex-col justify-between gap-4 rounded-[20px] border border-brand-strong px-7 py-8 transition-all hover:bg-brand-green-50 dark:border-secondary dark:bg-secondary dark:hover:border-brand-subtle dark:hover:bg-brand-green-25',
        props.isCompleted &&
          'border-[var(--purple-50)] bg-[var(--purple-25)] hover:border-[var(--purple-300)] hover:bg-[var(--purple-25)] dark:border-[#382e50] dark:bg-[#382e50] dark:hover:border-[var(--purple-600)] dark:hover:bg-[#382e50]'
      )}
    >
      <div className="space-y-2">
        <Text variant="h2" weight="normal" className="leading-[1.3]">
          {props.title}
        </Text>
        <Text
          variant="h3"
          color="tertiary"
          weight="normal"
          className={cn(props.isCompleted && 'invisible')}
        >
          {props.description}
        </Text>
      </div>
      <div className="flex justify-end">
        {props.isCompleted ? (
          <CheckIcon
            className={cn(
              '-mb-4 -mr-2.5 h-14 w-14 font-medium transition-transform group-hover:-translate-y-1 group-hover:translate-x-1 [&_path]:stroke-[0.6px]',
              props.isCompleted &&
                'group-hover:translate-x-0 group-hover:translate-y-0'
            )}
          />
        ) : (
          <ArrowUpRightIcon
            className={cn(
              '-mb-4 -mr-4 h-16 w-16 font-medium transition-transform group-hover:-translate-y-1 group-hover:translate-x-1 [&_path]:stroke-[0.6px]',
              props.isCompleted &&
                'group-hover:translate-x-0 group-hover:translate-y-0'
            )}
          />
        )}
      </div>
    </div>
  );
}
